import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { dnAlert } from "./utils/dNews_Alert";
import { FaPenSquare, FaTrashAlt } from "react-icons/fa";
import { apiFetch } from "./utils/api";
import logo_eagle from "./assets/img/logo_eagle.png";
import "./dSpr.css";
import "./Leave_configuration.css";

function LeaveConfiguration({ navSize }) {
    const [leaveList, setLeaveList] = useState([]);
    const [loadingList, setLoadingList] = useState(true);
    const [formData, setFormData] = useState({
        leave_type: "",
        max_leave: "",
        is_paid: 1,        // paid by default
    });
    const [editId, setEditId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchLeaves();
        fetchloginedEmployees();
    }, []);

    const fetchloginedEmployees = async () => {
        try {
            const res = await apiFetch(`/api/employee/logined_employee`, {
                method: 'GET',
                credentials: 'include',
            });
            const data = await res.json();
             
            if (data?.message === "Access Denied. No Token Provided!" ||
                data?.message === "Invalid Token") {
                navigate("/login");
                return;
            }

            // Role redirect removed - ProtectedRoute (App.js) gates via matrix.

        } catch (err) {
            console.error("Error fetching employees:", err);
        }
    };

    const fetchLeaves = async () => {
        setLoadingList(true);
        try {
            const res = await apiFetch("/api/leave/leave_type_list?include_unpaid=1");
            const data = await res.json();
            setLeaveList(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("❌ Fetch error:", err);
        } finally {
            setLoadingList(false);
        }
    };

    const handleSave = async () => {
        const { leave_type, max_leave } = formData;

        if (!leave_type || !max_leave) {
            dnAlert.error("Validation Error", "All fields are required");
            return;
        }

        const url = editId
            ? `/api/leave/update_leave_type/${editId}`
            : "/api/leave/add_leave_type";
        const method = editId ? "PUT" : "POST";

        try {
            const res = await apiFetch(url, {
                method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
                credentials: 'include',
            });

            const data = await res.json();

            if (data.success) {
                dnAlert.success("Success", data.message);
                setFormData({ leave_type: "", max_leave: "", is_paid: 1 });
                setEditId(null);
                fetchLeaves();
            }
        } catch (err) {
            dnAlert.error("Error", "Something went wrong");
        }
    };

    const handleEdit = (item) => {
        setFormData({
            leave_type: item.leave_type,
            max_leave: item.max_leave,
            is_paid: Number(item.is_paid) === 0 ? 0 : 1,
        });
        setEditId(item.leave_type_id);
    };

    const handleDelete = async (id) => {
        const ok = await dnAlert.confirm({
            title: "Delete leave type?",
            message: "This will permanently delete the leave type.",
            confirmLabel: "Delete",
            danger: true,
        });
        if (!ok) return;
        try {
            const res = await apiFetch(`/api/leave/delete_leave_type/${id}`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                credentials: 'include',
            });
            const data = await res.json();
            if (data.success) {
                dnAlert.success("Deleted", data.message);
                fetchLeaves();
            }
        } catch {
            dnAlert.error("Error", "Something went wrong");
        }
    };

    return (
        <div className="leave-config-container">
            <div className={`leave-config-dashboard ${navSize}`}>
                <div className="dspr-header-wrapper">
                    <h2>
                        <a className="navbar-brand" href="#">
                            <img
                                src={logo_eagle}
                                alt="dAdmin Logo"
                                style={{
                                    height: "50px",
                                    objectFit: "contain",
                                    marginLeft: "-20px",
                                }}
                            />
                        </a>
                        Leave Configuration
                    </h2>
                    <p className="dspr-subtitle">Master list of leave types and the maximum days allowed per type per employee.</p>
                </div>
                <div className={`leave-config-content`}>
                    <div className="leave-form">
                        <input
                            type="text"
                            placeholder="Leave type"
                            value={formData.leave_type}
                            onChange={(e) => setFormData({ ...formData, leave_type: e.target.value })}
                        />
                        <input
                            type="text"
                            placeholder="Max leave"
                            value={formData.max_leave}
                            onChange={(e) => {
                                const value = e.target.value;

                                // Allow only numbers
                                if (!/^\d*$/.test(value)) return;

                                // Limit value to 30
                                if (Number(value) > 30) {
                                    dnAlert.error("Validation Error", "Max Leave cannot exceed 30");
                                    return;
                                }

                                setFormData({ ...formData, max_leave: value });
                            }}
                        />
                        <label className="leave-paid-toggle" title="Unpaid types are never selectable when applying - they're an approval outcome only.">
                            <input
                                type="checkbox"
                                checked={Number(formData.is_paid) !== 0}
                                onChange={(e) => setFormData({ ...formData, is_paid: e.target.checked ? 1 : 0 })}
                            />
                            <span>Paid leave</span>
                        </label>
                        <button className="btn btn-success" onClick={handleSave}>
                            {editId ? "Update" : "Save"}
                        </button>
                    </div>

                    <table className="leave-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Leave Type</th>
                                <th>Max Leave</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loadingList ? (
                                <tr><td colSpan="4" className="leave-table-empty">Loading…</td></tr>
                            ) : leaveList.length === 0 ? (
                                <tr><td colSpan="4" className="leave-table-empty">No leave types yet. Add one above.</td></tr>
                            ) : leaveList.map((item, idx) => (
                                <tr key={item.leave_type_id}>
                                    <td>{idx + 1}</td>
                                    <td>{item.leave_type}</td>
                                    <td>{item.max_leave}</td>
                                    <td>
                                        <button
                                            className="lc-icon-btn"
                                            title="Edit"
                                            onClick={() => handleEdit(item)}
                                        >
                                            <FaPenSquare />
                                        </button>
                                        <button
                                            className="lc-icon-btn lc-icon-btn--danger"
                                            title="Delete"
                                            onClick={() => handleDelete(item.leave_type_id)}
                                        >
                                            <FaTrashAlt />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    );
}

export default LeaveConfiguration;
